import { Health16 } from 'ui/icons/aurora/16px/Health16';
import { MissionControlModule } from 'modules/missionControl/constants';
import { ErrorBoundary } from 'modules/error/ErrorBoundary';
import { Team } from 'teams';
import { Product } from 'teams';
import { CampaignsHealthDashboard } from './CampaignsHealthDashboard';
import {
  DashboardSection,
  DashboardSectionHeader,
  DashboardSectionTitle,
} from '../Dashboard.styled';
import { HomepageErrorBoundaryState } from '../HomepageErrorBoundaryState';

export const HealthDashboard = () => {
  return (
    <DashboardSection data-test="health-dashboard">
      <DashboardSectionHeader>
        <DashboardSectionTitle>
          <Health16 /> Health
        </DashboardSectionTitle>
      </DashboardSectionHeader>

      <ErrorBoundary
        teamName={Team.NOVA_TEAM}
        productName={Product.HOMEPAGE}
        errorContext={{
          module: MissionControlModule.HEALTH_DASHBOARD,
        }}
        errorMarkup={
          <HomepageErrorBoundaryState data-test="health-dashboard-error-boundary-state" />
        }
      >
        <CampaignsHealthDashboard />
      </ErrorBoundary>
    </DashboardSection>
  );
};
